<template>
  <main class="layout">
    <UContainer class="mt-8 2xl:mt-20"><slot /></UContainer>
  </main>
</template>
